export default `
    {{ variable }} = hmUI.createWidget(hmUI.widget.TEXT_TIME, {
      {{ #timeData }}
      {{ key }}_zero: {{ padding_zero }},
      {{ ^follow }}
      {{ key }}_startX: {{ position.x }},
      {{ key }}_startY: {{ position.y }},
      {{ /follow }}
      {{ key }}_color: {{ color }},
      {{ key }}_font_size: {{ fontSize }},
      {{ ^follow }}
      {{ key }}_space: {{ interval }},
      {{ /follow }}
      {{ #unitSC }}
      {{ key }}_unit_sc: '{{{ unitSC }}}',
      {{ /unitSC }}
      {{ #unitTC }}
      {{ key }}_unit_tc: '{{{ unitTC }}}',
      {{ /unitTC }}
      {{ #unitEN }}
      {{ key }}_unit_en: '{{{ unitEN }}}',
      {{ /unitEN }}
      {{ ^follow }}
      {{ key }}_align: {{ align }},
      {{ /follow }}
      {{ #showFollow }}
      {{ key }}_follow: {{ follow }},
      {{ /showFollow }}
      {{ /timeData }}
      {{ #ampmData }}
      {{ key }}_x: {{ position.x }},
      {{ key }}_y: {{ position.y }},
      {{ #imageSC }}
      {{ key }}_sc_path: '{{{ imageSC }}}',
      {{ /imageSC }}
      {{ #imageEN }}
      {{ key }}_en_path: '{{{ imageEN }}}',
      {{ /imageEN }}
      {{ /ampmData }}
      show_level: {{ showLevel }},
    });
`
